interface IManualScrollSuggestionsDropdownArgs {
  $event: KeyboardEvent;
  isSuggestionsDropdownOpen: boolean;
}

export function manualScrollSuggestionsDropdown(args: IManualScrollSuggestionsDropdownArgs): void {
  if ((args.$event.key === "ArrowUp" || args.$event.key === "ArrowDown") && args.isSuggestionsDropdownOpen) {
    // We need setTimeout in order to select the correctly selected assignee chip
    setTimeout(() => {
      const suggestionsDropdownEl = document.getElementsByTagName("suggestions-dropdown")[0];
      const assigneeChipEl = document.getElementsByClassName("no-background no-border-radius selected")[0];
      const suggestionsDropdownBorderSize = 1;

      const assigneeChipElOffsetBottom =
        assigneeChipEl.getBoundingClientRect().bottom - suggestionsDropdownEl.getBoundingClientRect().top - suggestionsDropdownBorderSize;
      const scrollToTop =
        assigneeChipElOffsetBottom - (suggestionsDropdownEl.getBoundingClientRect().height - 2 * suggestionsDropdownBorderSize) + suggestionsDropdownEl.scrollTop;
      suggestionsDropdownEl.scrollTo({ top: scrollToTop });
    });
  }
}
